import api from '@/api';

class PropertyAssessmentTypeStatus {
  /**
   * @returns {string}
   * @constructor
   */
  static AVAILABLE() {
    return 'Available';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static NOT_APPLICABLE() {
    return 'N/A';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static VOID() {
    return 'Void';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static UNDER_REFURBISHMENT() {
    return 'Under Refurb';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static MANAGING_AGENT() {
    return 'Man. Agent';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static INCLUDED_IN_OTHER_RA() {
    return 'Inc. Other RA';
  }

  static list() {
    return api.get('/properties/assessment-types/statuses');
  }
}

export default PropertyAssessmentTypeStatus;
